var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractiveBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.4 175C58.9775 175 25.4001 141.423 25.4001 100C25.4001 58.5774 58.9775 25 100.4 25C141.823 25 175.4 58.5774 175.4 100C175.4 141.423 141.823 175 100.4 175Z",
    fill: "url(#paint0_linear_26801_1246)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.366 155.373C111.114 151.394 133.263 143.066 165.002 143.272V63.4959C165.002 63.4959 160.934 63.3808 154.48 63.9047V138.512L149.133 138.467C136.949 138.36 125.061 141.307 114.351 147.097C110.559 149.144 105.619 152.281 102.368 155.371L102.366 155.373ZM95.5494 149.706C89.2654 144.622 72.1087 132.946 47.2244 133.161V53.3848C47.2244 53.3848 74.4397 52.3408 95.5494 70.0873V149.706ZM100.852 70.0922C121.961 52.3457 149.177 53.3897 149.177 53.3897V133.166C124.292 132.951 107.134 144.626 100.852 149.711L100.852 70.0922ZM41.9218 63.9057C35.4727 63.3817 31.4001 63.4969 31.4001 63.4969V143.273C63.142 143.067 85.2881 151.395 94.0365 155.374C90.7851 152.283 85.8461 149.146 82.0537 147.099C71.3422 141.309 59.4505 138.362 47.2713 138.469L41.9238 138.514V63.9068L41.9218 63.9057Z",
    fill: "url(#paint1_linear_26801_1246)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1979 56.6017C90.3016 56.6017 95.2497 51.6526 95.2497 45.5476C95.2497 39.4426 90.3016 34.4935 84.1979 34.4935C78.0941 34.4935 73.146 39.4426 73.146 45.5476C73.146 51.6526 78.0941 56.6017 84.1979 56.6017Z",
    fill: "url(#paint2_linear_26801_1246)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1968 34.4935C90.3005 34.4935 95.2487 39.4426 95.2487 45.5476C95.2487 51.6526 90.3005 56.6017 84.1968 56.6017C83.9449 56.6017 83.6952 56.5926 83.4475 56.5759C89.2016 56.1904 93.7501 51.4006 93.7501 45.5476C93.7501 39.6946 89.2018 34.9048 83.4475 34.5192C83.6951 34.5026 83.9449 34.4935 84.1968 34.4935Z",
    fill: "url(#paint3_linear_26801_1246)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4781 45.9932L85.2746 48.4207L81.071 50.8481C80.9074 50.9425 80.72 50.9425 80.5564 50.8481C80.3927 50.7535 80.2991 50.5913 80.2991 50.4023V45.5474V40.6927C80.2991 40.5037 80.3927 40.3415 80.5564 40.2469C80.72 40.1525 80.9074 40.1525 81.071 40.2469L85.2746 42.6743L89.4781 45.1018C89.6418 45.1962 89.7354 45.3586 89.7354 45.5476C89.7354 45.7365 89.6418 45.8988 89.4781 45.9932Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.112 30H122.142C122.911 30 123.538 30.6134 123.538 31.3651V47.2354C123.538 47.9871 122.911 48.6005 122.142 48.6005H103.112C102.343 48.6005 101.716 47.9873 101.716 47.2354V31.3652C101.716 30.6132 102.343 30 103.112 30Z",
    fill: "url(#paint4_linear_26801_1246)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.607 30H122.141C122.911 30 123.538 30.6134 123.538 31.3651V47.2354C123.538 47.9871 122.91 48.6005 122.141 48.6005H120.607C121.377 48.6005 122.004 47.9871 122.004 47.2354V31.3652C122.004 30.6134 121.377 30 120.607 30Z",
    fill: "url(#paint5_linear_26801_1246)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.5 35.2952C115.573 33.9998 114.558 32.8919 113.232 32.8206C111.907 32.7493 110.773 33.7415 110.7 35.0369C110.627 36.3323 111.642 37.4402 112.968 37.5115C114.293 37.5828 115.427 36.5906 115.5 35.2952Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.716 42.859V47.2356C101.716 47.9874 102.343 48.6007 103.112 48.6007H122.142C122.911 48.6007 123.538 47.9873 123.538 47.2356V42.859L118.977 36.8877C118.896 36.7822 118.786 36.7215 118.652 36.7091C118.518 36.6966 118.397 36.7359 118.298 36.8245L112.072 42.3777L108.454 38.3882C108.295 38.2119 108.024 38.1858 107.832 38.3281L101.716 42.859Z",
    fill: "#CBD5E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.608 48.6007H122.142C122.911 48.6007 123.538 47.9873 123.538 47.2356V42.859L118.977 36.8877C118.896 36.7822 118.786 36.7215 118.652 36.7091C118.518 36.6966 118.398 36.7359 118.298 36.8245L117.761 37.3035L122.005 42.859V47.2356C122.005 47.9873 121.377 48.6007 120.608 48.6007ZM112.073 42.3779L108.455 38.3883C108.295 38.212 108.024 38.186 107.832 38.3282L107.255 38.7562L111.225 43.1339L112.073 42.3779Z",
    fill: "#CBD5E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.824 124.035C110.824 130.158 115.736 135.113 121.785 135.113C127.833 135.113 132.745 130.158 132.745 124.035C132.745 117.912 127.833 112.957 121.785 112.957C115.736 112.957 110.824 117.912 110.824 124.035Z",
    stroke: "url(#paint6_linear_26801_1246)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.784 132.051C126.166 132.051 129.718 128.462 129.718 124.035C129.718 119.609 126.166 116.02 121.784 116.02C117.402 116.02 113.85 119.609 113.85 124.035C113.85 128.462 117.402 132.051 121.784 132.051Z",
    fill: "url(#paint7_linear_26801_1246)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.063 116.02C126.291 116.02 129.718 119.609 129.718 124.035C129.718 128.462 126.291 132.051 122.063 132.051C121.668 132.051 121.281 132.019 120.903 131.959C124.58 131.374 127.398 128.049 127.398 124.035C127.398 120.021 124.58 116.696 120.903 116.111C121.281 116.051 121.668 116.02 122.063 116.02Z",
    fill: "url(#paint8_linear_26801_1246)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.032 144.55L119.1 127.149C117.952 125.137 118.64 122.541 120.629 121.38C122.618 120.218 125.185 120.915 126.333 122.926L134.486 137.209C133.886 135.323 134.646 133.191 136.407 132.162C138.405 130.996 140.983 131.667 142.175 133.666C142.08 132.224 142.779 130.779 144.094 130.012C145.932 128.938 148.305 129.581 149.366 131.44L149.679 131.989C149.816 130.834 150.468 129.753 151.535 129.131C153.332 128.081 155.649 128.709 156.686 130.526C161.453 138.879 162.152 140.102 165.431 145.847C166.327 147.418 166.747 148.968 166.768 150.781C166.774 151.363 166.933 151.945 167.242 152.488L169.146 155.822C169.517 156.473 169.295 157.31 168.652 157.686L147.877 169.818C147.234 170.194 146.406 169.969 146.034 169.318L144.132 165.984C143.501 164.878 142.419 164.244 141.157 164.239L136.253 164.22C133.479 164.209 130.913 163.217 129.319 160.921L125.096 154.838C123.02 151.2 124.189 147.379 127.783 145.28L129.032 144.55Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.206 130.443C150.524 129.916 150.971 129.459 151.534 129.131C153.331 128.081 155.648 128.709 156.685 130.526C161.452 138.879 162.151 140.102 165.43 145.847C166.326 147.418 166.747 148.968 166.767 150.781C166.774 151.363 166.932 151.945 167.242 152.488L169.145 155.822C169.516 156.473 169.295 157.31 168.651 157.686L165.535 159.505C166.179 159.129 166.401 158.292 166.029 157.641L164.126 154.307C163.816 153.764 163.658 153.183 163.651 152.601C163.631 150.787 163.211 149.237 162.314 147.667C159.035 141.922 158.337 140.699 153.569 132.346C152.857 131.099 151.542 130.412 150.206 130.443ZM142.173 133.666C140.982 131.667 138.404 130.996 136.406 132.162C135.85 132.487 135.393 132.922 135.048 133.424C136.614 133.291 138.198 134.042 139.058 135.485L140.408 137.852C140.905 138.722 142.005 139.02 142.866 138.518C143.726 138.015 144.021 136.902 143.524 136.032C143.074 135.243 142.624 134.455 142.173 133.666ZM142.758 131.314C144.142 131.264 145.512 131.968 146.249 133.26C146.567 133.816 146.884 134.372 147.202 134.929C147.698 135.799 148.799 136.097 149.659 135.595C150.52 135.093 150.814 133.98 150.318 133.109C150 132.553 149.682 131.997 149.365 131.44C148.303 129.581 145.931 128.938 144.092 130.012C143.53 130.34 143.081 130.791 142.758 131.314ZM119.275 122.649C119.616 122.143 120.071 121.705 120.628 121.38C122.617 120.218 125.184 120.915 126.332 122.926C129.642 128.726 132.953 134.526 136.264 140.327C136.76 141.197 136.466 142.31 135.605 142.812C134.745 143.315 133.645 143.017 133.148 142.146C129.837 136.346 126.527 130.546 123.216 124.745C122.389 123.297 120.827 122.531 119.275 122.649ZM126.049 146.603C126.541 146.112 127.12 145.667 127.783 145.28L129.032 144.551L133.298 152.025C133.795 152.896 133.5 154.009 132.64 154.511C131.779 155.013 130.679 154.715 130.182 153.845L126.049 146.603Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.131 165.984L167.242 152.487L169.145 155.821C169.517 156.472 169.295 157.31 168.651 157.686L147.877 169.818C147.234 170.193 146.406 169.969 146.034 169.318L144.131 165.984Z",
    fill: "url(#paint9_linear_26801_1246)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.127 154.307L167.243 152.487L169.146 155.821L169.163 155.852L169.179 155.883L169.194 155.914L169.208 155.946L169.222 155.977L169.234 156.009L169.246 156.041C169.25 156.052 169.254 156.062 169.258 156.073L169.268 156.105L169.277 156.137L169.286 156.17L169.293 156.202L169.3 156.235L169.306 156.268L169.312 156.301C169.313 156.312 169.314 156.323 169.316 156.334C169.318 156.356 169.32 156.378 169.322 156.4L169.324 156.433L169.325 156.466L169.326 156.499C169.326 156.52 169.325 156.543 169.324 156.564L169.322 156.597L169.32 156.63L169.316 156.662L169.312 156.695C169.309 156.716 169.305 156.738 169.301 156.76C169.297 156.781 169.293 156.802 169.287 156.823L169.279 156.855L169.27 156.887C169.264 156.908 169.258 156.928 169.25 156.949C169.243 156.97 169.236 156.99 169.228 157.01L169.216 157.041L169.202 157.071L169.189 157.1L169.174 157.13C169.164 157.149 169.154 157.168 169.143 157.188L169.127 157.216L169.109 157.244L169.091 157.271C169.079 157.29 169.066 157.308 169.053 157.325L169.033 157.352L169.012 157.377L168.991 157.403L168.969 157.428L168.946 157.452L168.922 157.476L168.898 157.499L168.874 157.522L168.848 157.544L168.822 157.566L168.796 157.587L168.768 157.608L168.741 157.627L168.712 157.646L168.683 157.665L168.653 157.683L165.537 159.503C166.181 159.127 166.403 158.289 166.031 157.639L164.127 154.307Z",
    fill: "#3460DC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1246",
    x1: 25.4001,
    y1: 36.7188,
    x2: 168.369,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1246",
    x1: 98.2012,
    y1: 53.3732,
    x2: 98.2012,
    y2: 155.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1246",
    x1: 75.5636,
    y1: 34.4935,
    x2: 101.127,
    y2: 50.4256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1246",
    x1: 84.7383,
    y1: 34.4935,
    x2: 101.799,
    y2: 40.1703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1246",
    x1: 112.627,
    y1: 30,
    x2: 112.627,
    y2: 48.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_1246",
    x1: 122.073,
    y1: 30,
    x2: 122.073,
    y2: 48.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_1246",
    x1: 130.738,
    y1: 112.457,
    x2: 104.082,
    y2: 128.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_1246",
    x1: 115.585,
    y1: 116.02,
    x2: 134.039,
    y2: 127.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26801_1246",
    x1: 121.867,
    y1: 116.02,
    x2: 134.534,
    y2: 120.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26801_1246",
    x1: 147.974,
    y1: 170,
    x2: 165.486,
    y2: 152.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveBook);
export default __webpack_public_path__ + "static/media/Interactive-Book.98771ec440ac42815fd5a5fcf17fd58f.svg";
export { ForwardRef as ReactComponent };